var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DsfFormControlBox", {
    staticClass: "ds-textbox",
    attrs: { owner: _vm._self },
    scopedSlots: _vm._u(
      [
        {
          key: "simple",
          fn: function () {
            return [
              _vm._v(" " + _vm._s(_vm.value) + " "),
              _vm._t("error", function () {
                return [
                  _vm.errors.length > 0
                    ? _c("div", { staticClass: "ds-error-text" }, [
                        _vm._v(" " + _vm._s(_vm.errorsMsg) + " "),
                      ])
                    : _vm._e(),
                ]
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "content",
          fn: function () {
            return [
              !_vm.readOnly
                ? _c("el-autocomplete", {
                    ref: "auto",
                    class: { "ds-error-border": _vm.errors.length > 0 },
                    attrs: {
                      "fetch-suggestions": _vm.querySearchAsync,
                      placeholder: _vm.placeholder,
                      disabled: _vm.disabled,
                      "trigger-on-focus": _vm.triggerOnFocus,
                      debounce: _vm.delay,
                    },
                    on: {
                      select: _vm.handleSelect,
                      blur: _vm.handleBlur,
                      change: _vm.handleChange,
                      input: _vm.handleInput,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _vm._t(
                                "default",
                                function () {
                                  return [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(item.__labelHtml),
                                      },
                                    }),
                                  ]
                                },
                                null,
                                { item: item }
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _vm.inputValue,
                      callback: function ($$v) {
                        _vm.inputValue = $$v
                      },
                      expression: "inputValue",
                    },
                  })
                : _vm.readOnly
                ? _c("div", { staticClass: "ds-form-readonly" }, [
                    _c("span", [_vm._v(_vm._s(_vm.value))]),
                  ])
                : _vm._e(),
              _vm._t("error", function () {
                return [
                  _vm.errors.length > 0
                    ? _c("div", { staticClass: "ds-error-text" }, [
                        _vm._v(" " + _vm._s(_vm.errorsMsg) + " "),
                      ])
                    : _vm._e(),
                ]
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }